import axios from 'axios';
import { useMutation } from '@tanstack/vue-query';

import http from '@/services/http';

const UPLOAD_URL = String(import.meta.env.VITE_SDOT_UPLOAD_URL || '');

function getLangHeader() {
  const translation = localStorage.getItem('translation');
  return translation === 'kz' ? 'kk-KZ' : 'ru-RU';
}

async function sendSosMessage(payload) {
  const response = await http.post('/sos/message', payload);
  return response?.data;
}

async function uploadSosFile(file) {
  if (!UPLOAD_URL) {
    throw new Error('VITE_SDOT_UPLOAD_URL is not configured');
  }

  const formData = new FormData();
  formData.append('Upload[finished]', false);
  formData.append('Upload[percent]', 0);
  formData.append('Upload[error]', false);
  formData.append('Upload[unzip]', 0);
  formData.append('yModel', 'Upload');
  formData.append('Upload[name]', file.name);
  formData.append('Upload[file]', file);

  const response = await axios.post(UPLOAD_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-lang': getLangHeader()
    }
  });

  const uploaded = response?.data || {};
  const hasProtocol = /^https?:\/\//i.test(uploaded.url || '');
  if (uploaded.url && !hasProtocol) {
    uploaded.url = `https://${uploaded.url}`;
  }

  return uploaded;
}

export function useSendSosMessageMutation() {
  return useMutation({
    mutationFn: sendSosMessage
  });
}

export function useUploadSosFileMutation() {
  return useMutation({
    mutationFn: uploadSosFile
  });
}
